/**
 * @generated SignedSource<<6ceabcc9c08a25543dae495b580cb341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RegistrationQuery$variables = {
  id: string;
};
export type RegistrationQuery$data = {
  readonly userBrandRegistrationForm: {
    readonly brand: {
      readonly id: string;
      readonly name: string;
    };
    readonly id: string;
  } | null | undefined;
};
export type RegistrationQuery = {
  response: RegistrationQuery$data;
  variables: RegistrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UserBrandRegistrationFormType",
    "kind": "LinkedField",
    "name": "userBrandRegistrationForm",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistrationQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegistrationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3ed94f944928975f75ebd55653a0b245",
    "id": null,
    "metadata": {},
    "name": "RegistrationQuery",
    "operationKind": "query",
    "text": "query RegistrationQuery(\n  $id: ID!\n) {\n  userBrandRegistrationForm(id: $id) {\n    id\n    brand {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9354804e6f9b768ddd17ca284d6cc93";

export default node;
